import React from 'react'
import { List, ListItem, CircularProgress } from '@material-ui/core'
import NewQuestionEditor from './component/NewQuestionEditor'
import Snack from '../Snack'

const api = require('../api/api')

class TreeItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hovered: false,
			open: false
		}
	}

	componentDidMount() {
		if (!this.props.value?.children) {
			return
		}
		
		for (let c of this.props.value.children) {
			this.props.fill.set(c.id, this)
		}
	}

	onMouseEnter() {
		this.setState({
			hovered: true
		})
	} 
	
	onMouseLeave() {
		this.setState({
			hovered: false
		})
	}

	onClick(e, data) {
		if (e.target.localName === 'a') {
			this.props.onAClick()
			return
		}

		this.setState({
			open: !this.state.open
		})
	}

	render() {
		return <div onClick={this.onClick.bind(this)}>
			<div style={{
				padding: 10,
				borderRadius: 5,
				background: this.state.hovered ? "#eee" : "#fff" 
			}} onMouseEnter={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}>
				<b>{this.props.value.id}. {this.props.value.name}</b>
				{this.props.value.lock && <i> Locked by: <a onClick={this.props.onClick} href={`#${this.props.value.lock.id}`}>{this.props.value.lock.id}</a>. {this.props.value.lock.text}</i>}
			</div>
			
			<div style={{
				display: this.state.open ? 'block' : 'none'
			}}>
				{this.props.children}
			</div>
		</div>
	}
}

export default class TreeTab extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			questions: null,
			topics: null,
			topicNames: []
		}

		this.questionEditor = React.createRef()
	}

	fetch() {
		api.questions.list().then(d => {
			api.topics.list().then(data => {
				let names = []
	
				for (let topic of data.topics) {
					names.push(topic.name)
				}
	
				this.setState({
					topics: data.topics,
					topicNames: names,
					questions: d.questions
				})
			}).catch(e => {
				console.error(e)
			})
		}).catch(err => {
			console.error(err)
		})
	}

	componentDidMount() {
		this.fetch()
	}

	edit(requestedId) {
		let id = -1

		for (let i in this.state.questions) {
			let row = this.state.questions[i]

			if (row.id == requestedId) {
				id = parseInt(i)
				break
			}
		}

		this.questionEditor.current.open(id, this.state.questions[id])
	}

	onClose() {
		const data = this.questionEditor.current.getData()

		api.questions.update(data).then((result) => {
			this.fetch()
		}).catch(err => {
			Snack.instance.show(err)
			console.error(err)

			this.setState({
				error: err,
				loading: false
			})
		})
	}

	openHeader(lockedBy) {
		if (!lockedBy) {
			return
		}

		let header = this.headers.get(lockedBy)

		if (!header) {
			return
		}

		header.setState({
			open: true
		})

		this.forceUpdate()
	}

	renderTree() {
		let topics = new Map()
		let questions = new Map()
		this.headers = new Map()

		for (let question of this.state.questions) {
			questions.set(question.id, question)
		}

		for (let topic of this.state.topics) {
			topics.set(topic.id, topic)

			if (topic.lockedBy) {
				topic.lock = questions.get(topic.lockedBy)
			}
		}

		for (let question of this.state.questions) {
			let parent = topics.get(question.topic)

			if (!parent) {
				continue
			}
			
			if (!parent.children) {
				parent.children = []
			}
			
			parent.children.push(question)
		}

		return <div> {Array.from(topics).map(([key, value]) => {
			return <TreeItem value={value} fill={this.headers} onAClick={this.edit.bind(this, value.lockedBy)} onClick={this.openHeader.bind(this, value.lockedBy)}>
				<List>
					{value.children && value.children.map(c => {
						return <ListItem key={c.id}><b><a id={c.id} href="#" onClick={this.edit.bind(this, c.id)}>{c.id}</a></b>. {c.text} </ListItem>
					})}

					{(!value.children || value.children.length == 0) && <ListItem><i>Nothing here yet</i></ListItem>}
				</List>

			</TreeItem>
		})} </div>
	}

	render() {
		return <>
			<NewQuestionEditor ref={this.questionEditor} onClose={this.onClose.bind(this)} topics={this.state.topicNames} />
			{this.state.questions && this.state.topics ? this.renderTree() : <CircularProgress size={48} />}
		</>
	}
}